import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_GRAY_90, COLOR_PINK } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: COLOR_PINK,
    lineHeight: '36px',
    textAlign: 'center',
  },
  description: {
    lineHeight: '24px',
    color: COLOR_GRAY_90,
    textAlign: 'center',
    padding: theme.spacing(2, 0),
  },
  benefitsList: {
    maxWidth: 510,
    lineHeight: '8px',

    '& div': {
      display: 'flex',
      alignItems: 'center',
      maxHeight: 35,
    },

    '& svg': {
      color: COLOR_PINK,
    },

    '& p': {
      color: COLOR_GRAY_70,
      fontSize: 16,
      fontFamily: 'Lato',
      marginLeft: 8,
      lineHeight: 1,
    },
  },
}));
